export default __webpack_public_path__ + "assets/webgl/matcap_clay.c3d7b5ed.jpg";